/**
 * weather.js
 */


export const isWeatherEmpty = (v) => {
  return (
    !v
    || (
      (!v.temperature || !v.temperature.name)
      && (!v.conditions || !v.conditions.name)
      && (!v.windSpeed || !v.windSpeed.name)
      && (!v.windDirection || !v.windDirection.name)
    )
  );
}


export const formatWeatherSummary = (v) => {
  if (isWeatherEmpty(v)) {
    return ' Not Provided';
  }

  const pt1 = 
    v.temperature && v.conditions 
      ? `${v.conditions.name} and ${v.temperature.name}`
      : v.temperature
        ? `${v.temperature.name}`
        : v.conditions
          ? `${v.conditions.name}`
          : '';
  const pt2 = v.windSpeed || v.windDirection
    ? `${v.windSpeed?.name || ''} ${v.windDirection?.name || ''} wind`
    : '';

  return ` ${pt1}${pt1 && pt2 ? ', ' : ''}${pt2}`;
}